const SUCCESS_AUTO_CLOSE = 3; // 成功自动关闭的秒数
const Failure_AUTO_CLOSE = 6; // 失败自动关闭的秒数
const ajax = {
    baseURL: process.env.NODE_ENV === 'development' ? '/api/' : '/',
    timeOut: 3000 * 1000,
    type: 'post',
    dataType: 'json',
    contentType: 'application/json; charset=utf-8',
    hooks: {},
    // 后端返回字段名配置
    response: {
        stateName: 'state', // 返回状态字段名
        stateSuccessValue: 'success', // 值为0表示请求成功
        dataName: 'data', // 返回数据的字段名
        msgName: 'msg' // 返回提示信息的字段名
    },
    ajaxListMap: {}
};
/**
 *  ajax 请求前的统一处理， 自行扩展
 *
 *
 */
ajax.hooks.eachBefore = function (param) {
    // 删除空参数
    if (param.data) {
        const exclude = [0, false];
        Object.keys(param.data).forEach((key) =>
            !param.data[key] && !exclude.includes(param.data[key]) ? delete param.data[key] : ''
        );
    }
    // 取消请求
    if (param.CANCEL) {
        param.CANCEL();
    }
    if (param.showLoading) {
        this.$Spin && this.$Spin.show();
    }
};

/**
 *  ajax 请求完成的统一处理， 自行扩展
 *
 *
 */
ajax.hooks.eachComplete = function (response, param) {
    if (param.showLoading) {
        this.$Spin && this.$Spin.hide();
    }
};

/**
 *  ajax 请求失败的统一处理， 自行扩展
 *
 *
 */
ajax.hooks.eachFailure = function (response, param) {
    let ajaxTip = param.ajaxFailTip || param.ajaxTip;
    let code = response[ajax.response.stateName];
    let msg = '';
    if (ajaxTip) {
        let failCodes = {
            401: '登录过期',
            1000: '登录过期'
        };
        if (Object.keys(failCodes).includes(code)) {
            msg = failCodes[code];
        } else {
            msg = response[ajax.response.msgName];
        }
        this.$Message.error({
            closable: true,
            content: msg || this.$t('msg.requestFailed'),
            duration: Failure_AUTO_CLOSE
        });
    }
    switch (parseInt(code)) {
        case 1000:
        case 401:
            break;
    }
};

/**
 *  ajax 请求成功的统一处理， 自行扩展
 *
 *
 */
ajax.hooks.eachSuccess = function (response, param) {
    let ajaxTip = param.ajaxSuccessTip || param.ajaxTip;
    if (ajaxTip) {
        this.$Message.success({
            closable: true,
            content: response[ajax.response.msgName] || '处理成功',
            duration: SUCCESS_AUTO_CLOSE
        });
    }
};
export default ajax;
